export const patientImport = {
  PatientImport: "Patient import",
  ImportPatientsIn3Steps: "Import {{patientTermPlural}} in <3>3 simple steps</3>",
  FollowTheInstructions:
    "Follow the instructions below to bring your {{patientTermPlural}} into the Fullscript platform.",
  FollowingPatientsNotImported:
    "The following {{patientTermPlural}} were not imported. Correct the errors to import them.",
  DownloadCSVTemplate: "Download our CSV template to get started",
  DownloadTemplate: "Download template",
  UsingAnExistingCSVFile: "Using an existing CSV file?",
  UseExactHeadings: "Use these exact headings: {{headers}}.",
  UseYourOwnFile: "Use your own file",
  DragAndDropTemplateHere: "Drag & drop template here",
  BrowseComputer: "Browse computer",
  AreYouSureYouWantToDeleteThisFile: "Are you sure you want to remove this file?",
  AreYouSureYouWantToDeleteThisPatient: "Are you sure you want to remove this {{patientTerm}}?",
  AttachYourFile: "Attach your file",
  WantToInformYourPatients: "Want to inform your {{patientTermPlural}}?",
  WellSendAnEmail:
    "We'll send an email explaining that you've set them up on Fullscript. <2>Preview email</2>",
  SendInviteEmail: "Send invite email to all {{patientTermPlural}}",
  YouMustAttach: "Attach a file to proceed to the import step",
  CSVUploadError: "Error uploading CSV. Please try again",
  UploadedSuccessfully: "Uploaded successfully",
  ErrorsFound: "Errors Found",
  DownloadCSV: "Download CSV",
  TooManyErrorsMessage:
    "It looks like you're missing columns and/or have duplicates in your file! Please download the CSV below and correct the highlighted errors.",
  FullscriptScan:
    "Fullscript will scan your file to ensure patient information is formatted correctly. If there are errors, you will have the opportunity to correct them before importing.",
  WhileYouWait: "While you wait...",
  CheckOutHowEasyItIs:
    "Check out how easy it is to recommend supplements to your {{patientTermPlural}}!",
  ViewRecommendationTool: "View recommendation tool",
  ImportInProgress: "Import in progress",
  YouAreImportingPatients:
    "You are importing <2>{{entryCount}} {{patientTermPlural}}</2> into <5>Fullscript</5>. This import may take a while. Feel free to use our other features while you wait. You will be notified when the import is complete.",
  ItllBeWorthTheWait: "It'll be worth the wait...",
  SomePatientsWereNotImported:
    "Some {{patientTermPlural}} were not imported. <4>Correct errors here.</4>",
  YouHaveSuccessfullyImportedPatients:
    "Your import was partially successful. Some {{patientTermPlural}} were not imported. <4>Correct errors here.</4>",
  YourPatientImportIsComplete: "Your patient import is complete.",
  YourPatientImportIsInProgress: "Your {{patientTerm}} import is in progress.",
  DismissNotification: "Dismiss this notification",
  StartOver: "Start over",
  Import: "Import",
  StartYourImport: "Start your import!",
  StartImport: "Start import",
  ImportComplete: "Import complete",
  YourPatientImportIsCompleteModal:
    "You have successfully imported <2>{{entryCount}} {{patientTermPlural}}</2>. These {{patientTermPlural}} can be accessed in your {{patientTerm}} list. Write recommendations, share protocols, and so much more on Fullscript.",
  UploadFailed: "Upload failed: {responseStatus}",
  ImportFailure: "Import failure",
  TheCSVYouUploaded:
    "We had trouble reading the CSV you uploaded. Please upload a properly formatted CSV, or use the sample CSV provided as a guide.",
  NewPrescription: "Create new {{treatmentPlanTerm}}",
} as const;
